var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBalcony = function SvgBalcony(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.067,
    height: 35.954,
    viewBox: "0 0 31.067 35.954"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    width: 31.067,
    height: 35.954,
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    x1: 3.326,
    transform: "translate(0 16.485)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    x1: 3.326,
    transform: "translate(27.741 16.095)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    y2: 19.82,
    transform: "translate(2.848 15.959)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    y2: 19.82,
    transform: "translate(11.003 15.959)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    y2: 19.82,
    transform: "translate(20.211 15.959)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    y2: 19.82,
    transform: "translate(28.301 15.607)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    x2: 26.571,
    transform: "translate(2.302 35.427)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    width: 24.025,
    height: 11.705,
    transform: "translate(3.574 0.527)",
    fill: "none",
    stroke: "#002238",
    strokeWidth: 1
  }))));
};

export { SvgBalcony as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfOTAiICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzEuMDY3IiBoZWlnaHQ9IjM1Ljk1NCIgdmlld0JveD0iMCAwIDMxLjA2NyAzNS45NTQiPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwLXBhdGgiPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzEzOSIgIHdpZHRoPSIzMS4wNjciIGhlaWdodD0iMzUuOTU0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDIyMzgiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGcgaWQ9Ikdyb3VwXzg5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBjbGlwLXBhdGg9InVybCgjY2xpcC1wYXRoKSI+CiAgICA8bGluZSBpZD0iTGluZV85NyIgIHgxPSIzLjMyNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAxNi40ODUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDIyMzgiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfOTgiIHgxPSIzLjMyNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjcuNzQxIDE2LjA5NSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMjIzOCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8bGluZSBpZD0iTGluZV85OSIgeTI9IjE5LjgyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjg0OCAxNS45NTkpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDIyMzgiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMTAwIiB5Mj0iMTkuODIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExLjAwMyAxNS45NTkpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDIyMzgiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMTAxIiB5Mj0iMTkuODIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwLjIxMSAxNS45NTkpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDIyMzgiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMTAyIiB5Mj0iMTkuODIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI4LjMwMSAxNS42MDcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDIyMzgiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMTAzIiB4Mj0iMjYuNTcxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjMwMiAzNS40MjcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDIyMzgiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xMzgiIHdpZHRoPSIyNC4wMjUiIGhlaWdodD0iMTEuNzA1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjU3NCAwLjUyNykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMjIzOCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgPC9nPgo8L3N2Zz4K";